import { type MetaFunction } from '@remix-run/node'
import productProfessional from './product-professional.png'

export const meta: MetaFunction = () => [
	{ title: 'Professional Liability Insurance' },
	{
		name: 'description',
		content:
			'Commonly referred to as errors and omissions insurance or malpractice insurance, professional liability insurance protects your business against claims of negligence, misrepresentation, or mistake.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">
				Professional Liability Insurance
			</h1>
			<img
				src={productProfessional}
				alt="A man in a suit"
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We can help you find options for Professional liability insurance.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Commonly referred to as errors and omissions insurance or malpractice
				insurance, professional liability insurance protects your business
				against claims of negligence, misrepresentation, or mistake.
			</p>

			<h2>Who needs professional liability insurance?</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Professional liability insurance is recommended for any business that
				provides a service to clients. If you make a mistake or fail to complete
				a service, you could be held liable for damages. Professional liability
				insurance protects you against these claims.
			</p>

			<h2>What does professional liability insurance cover?</h2>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Professional liability insurance covers claims of negligence, mistakes,
				and misrepresentation. It also covers the cost of legal defense and
				court costs.
			</p>
		</main>
	)
}
